import isArray from 'lodash/isArray'
import { APPConfig } from 'config/appConfig'
import { convertToBoolean } from 'src/utils'
import { getLocaleCodeFromUrl } from 'src/utils/localeUtils'

const SHIPPING_ADDRESS_FORM_TYPES = [
  'addressBook',
  'checkout',
  'convertAccount',
  'legalAddress',
  'payment',
  'subscription',
]

function getLanguageFromLocale(locale = '') {
  return (locale.replace('-', '_').split('_')[0] || '').toLowerCase()
}

function isShippingAddressFormEnabled(flagConfig, country = '') {
  const countryCode = country.toUpperCase()

  if (typeof flagConfig === 'boolean') {
    return flagConfig
  }

  if (typeof flagConfig === 'string' || typeof flagConfig === 'number') {
    try {
      return convertToBoolean(flagConfig)
    } catch (e) {
      return false
    }
  }

  if (isArray(flagConfig)) {
    return flagConfig
      .map(value => String(value).toUpperCase())
      .includes(countryCode)
  }

  if (flagConfig && typeof flagConfig === 'object') {
    const lowerCountryCode = countryCode.toLowerCase()
    const countryFlag = Object.prototype.hasOwnProperty.call(
      flagConfig,
      countryCode
    )
      ? flagConfig[countryCode]
      : flagConfig[lowerCountryCode]

    if (countryFlag !== undefined) {
      return isShippingAddressFormEnabled(countryFlag, country)
    }

    if (flagConfig.enabled !== undefined) {
      return isShippingAddressFormEnabled(flagConfig.enabled, country)
    }

    if (flagConfig.countries !== undefined) {
      return isShippingAddressFormEnabled(flagConfig.countries, country)
    }
  }

  return false
}

function getShippingAddressFormFlag(appConfig = {}) {
  return appConfig?.useSmartyAddressForm !== undefined
    ? appConfig?.useSmartyAddressForm
    : appConfig?.equinoxStorefrontConfig?.useSmartyAddressForm
}

function getShippingAddressFormLocale(appConfig = {}) {
  return (
    getLocaleCodeFromUrl({ defaultLocale: appConfig?.defaultLocale }) ||
    appConfig?.defaultLocale ||
    'en_US'
  )
}

function getShippingAddressFormLanguage(appConfig = {}) {
  return getLanguageFromLocale(getShippingAddressFormLocale(appConfig))
}

function shouldUseShippingAddressForm({
  appConfig = APPConfig?.getAppConfig?.() || {},
  country = '',
  type = '',
} = {}) {
  return (
    SHIPPING_ADDRESS_FORM_TYPES.includes(type) &&
    isShippingAddressFormEnabled(getShippingAddressFormFlag(appConfig), country)
  )
}

export {
  getLanguageFromLocale,
  getShippingAddressFormFlag,
  getShippingAddressFormLanguage,
  getShippingAddressFormLocale,
  isShippingAddressFormEnabled,
  shouldUseShippingAddressForm,
}
